module.exports = __webpack_public_path__ + "assets/img/bg.7f0a3bb6.png";